import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useEventListener } from '../../hooks'
import { getAtomicAsset } from '../helpers/Api'
import { MarketInfoDetails } from '../marketinfo/MarketInfoDetails'
import { AssetPreviewImage } from './AssetPreviewImage'
import MarketPreviewDetailsTable from './MarketPreviewDetailsTable'

export const AssetPreviewInfo = ({
    cancel,
    asset,
    newOwner,
    currentAsset,
    bundleView,
    buttons,
}) => {
    const [atomicData, setAtomicData] = useState(null)

    const { t } = useTranslation('common')

    let {
        assetId,
        templateId,
        assets,
        collection,
        schema,
        bundle,
        contract,
        symbol,
        buyer,
    } = asset

    const getAtomicData = () => {
        const controller = new AbortController()
        if (contract === 'atomicassets')
            getAtomicAsset(assetId)
                .then((res) => {
                    res && res.success && setAtomicData(res.data)
                })
                .catch((e) => {
                    console.error(e)
                })
        return () => controller.abort()
    }

    const keyHandler = ({ key }) => {
        const ESCAPE_KEYS = ['27', 'Escape']
        if (ESCAPE_KEYS.includes(String(key))) {
            cancel()
        }
    }

    useEventListener('keydown', keyHandler)

    useEffect(() => {
        if (!atomicData) {
            getAtomicData()
        }
    }, [assetId])

    return (
        <div className={cn('absolute flex w-full')}>
            <div
                className={cn(
                    'w-full flex flex-col md:flex-row  justify-center shadow-xl',
                    'backdrop-blur-xl text-xs md:text-sm ',
                    'bg-paperd rounded-sm md:rounded-2xl ',
                )}
            >
                <div className=" grid rounded-l-lg dark:bg-zinc-950 bg-zinc-200 md:w-1/3 place-content-center md:h-full">
                    <AssetPreviewImage
                        asset={assets ? assets[0] : asset}
                        currentAsset={currentAsset}
                    />
                </div>

                <div className="overflow-y-auto md:w-2/3 dark:bg-zinc-900 bg-zinc-100">
                    <div className="mx-5 mt-5 mb-4">
                        <MarketPreviewDetailsTable
                            asset={asset}
                            newOwner={newOwner}
                            bundleView={bundleView}
                            currentAsset={currentAsset}
                            atomicData={atomicData}
                            showData={false}
                            className="none"
                        />
                        <MarketInfoDetails
                            asset={asset}
                            currentAsset={currentAsset}
                            assets={assets}
                            bundle={bundle}
                            cancel={cancel}
                            className="my-1 "
                        />
                        {!buyer ? (
                            <div className="h-24 mx-5 mb-4">{buttons}</div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
